import { useState } from "react";
import { Bell, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const RemindMe = ({ event }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | busy | done | error

  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    try {
      const res = await fetch(`${API}/event-reminders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ event_id: event.id, email }),
      });
      setState(res.ok ? "done" : "error");
    } catch {
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <p data-testid={`remind-done-${event.id}`} className="mt-3 text-xs text-[#2DE2E6] font-bold flex items-center justify-center gap-1.5">
        <Check className="w-3.5 h-3.5" /> We&apos;ll email you the day before
      </p>
    );
  }

  if (!open) {
    return (
      <button
        data-testid={`remind-${event.id}`}
        onClick={() => setOpen(true)}
        className="mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#26153F] border border-[#3B2760] text-[#A08FB8] text-[10px] font-bold uppercase mono-lbl hover:text-[#2DE2E6] hover:border-[#2DE2E6] transition-colors"
      >
        <Bell className="w-3.5 h-3.5" />
        Remind Me
      </button>
    );
  }

  return (
    <form data-testid={`remind-form-${event.id}`} onSubmit={submit} className="mt-3 flex gap-1.5">
      <input
        data-testid={`remind-email-${event.id}`}
        type="email"
        required
        placeholder="your@email.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 min-w-0 px-3 py-1.5 rounded-full bg-[#1B0F2E] border border-[#3B2760] text-[#F5EFE6] text-xs placeholder-[#A08FB8] focus:outline-none focus:border-[#FF2E88]"
      />
      <button
        data-testid={`remind-submit-${event.id}`}
        type="submit"
        disabled={state === "busy"}
        className="px-3 py-1.5 rounded-full bg-[#FF2E88] text-white text-[10px] font-bold uppercase mono-lbl hover:bg-[#D61F73] transition-colors disabled:opacity-50"
      >
        {state === "busy" ? "…" : "Sign Up"}
      </button>
      {state === "error" && <p className="text-[10px] text-[#FF2E88]">Try again</p>}
    </form>
  );
};
